import api from "../../services/api";
import { types } from "../types/types";
import Constants from "../../services/constant";
import { showToast } from "./toastAction";

const getGasFeesCurrencyList = (setLoading) => async (dispatch) => {
    console.log('reaeched')
    if (setLoading) {
        setLoading(true);
    }
    const res = await api("get", Constants.END_POINT.GAS_FEES);
    if (res.success) {
        if (res.data) {
            dispatch({
                type: types.GAS_FEES,
                payload: res.data
            });
        } else {
            dispatch({
                type: types.GAS_FEES,
                payload: []
            });
        }
    } else {
        dispatch({
            type: types.GAS_FEES,
            payload: []
        });
    }
    if (setLoading) {
        setLoading(false);
    }
};

const updateGasFees = (id, data, setLoading) => async (dispatch) => {
    setLoading(true);

    const payload = {
        ...data,
    };

    const res = await api("put", Constants.END_POINT.UPDATE_GAS_FEES + id, payload);
    if (res.success) {
        dispatch(showToast({ severity: "success", summary: res.message }));
        dispatch(getGasFeesCurrencyList(setLoading));
    } else {
        // BUG FIX: failure branch was showing a green "success" toast for a
        // failed operation. Use "error" so the user gets accurate feedback.
        dispatch(showToast({ severity: "error", summary: res.message || "Failed to update gas fee" }));
        if (setLoading) setLoading(false);
    }
};

const deleteGasFees = (id, setLoading) => async (dispatch) => {
    setLoading(true);
    const res = await api("delete", Constants.END_POINT.DELETE_GAS_FEES + id);
    if (res.success) {
        dispatch(showToast({ severity: "success", summary: res.message }));
        dispatch(getGasFeesCurrencyList(setLoading));
    } else {
        // BUG FIX (severity): same copy-paste bug as updateGasFees above.
        // BUG FIX (loading): the failure path now resets setLoading(false)
        // so a failed delete doesn't leave the table in a permanent loading state.
        dispatch(showToast({ severity: "error", summary: res.message || "Failed to delete gas fee" }));
        if (setLoading) setLoading(false);
    }
};

export { getGasFeesCurrencyList, updateGasFees, deleteGasFees };
